import styled from 'styled-components';
import { token } from '@zillow/constellation';

export const DropdownTriggerButton = styled.button`
    background: none;
    border: 0;
    display: flex;
    padding: 0 25px;
    align-items: center;
    color: ${token('colors.brand')};
    min-height: 53px;
    box-sizing: border-box;
    position: relative;
    &::before {
        position: absolute;
        content: '';
        border-right: 1px solid ${token('colors.borderLight')};
        height: 28px;
        left: 0;
    }
`;
